import { Table } from "react-bootstrap";
import { formatAddress } from "../../../../../helper";
import { EXPLORER_URL, URL } from '../../../../../utils/constant';
export default function ActivityTable({ activities, token }) {
  // console.log(token, "Token in activity table");

  // ✅ Safe number formatting helper
  const formatNumber = (value, decimals = 4) => {
    if (value === undefined || value === null || value === "" || isNaN(value)) return "0";
    return Number(value).toLocaleString(undefined, { maximumFractionDigits: decimals });
  };

  return (
    <Table responsive>
      <thead>
        <tr>
          <th>Date</th>
          <th>Activity</th>
          <th>Amount</th>
          <th>TX Hash</th>
        </tr>
      </thead>
      <tbody>
        {activities.map((act, i) => (
          <tr key={i}>
            <td>
              <div className="span_tab">
                <p>{act.date}</p>
                <span>{act.time}</span>
              </div>
            </td>

            <td>
              <p>{act.type}</p>
            </td>

            <td>
              <p>{`${formatNumber(act.amount)} ${token}`}</p>
            </td>

            <td>
              <p className="flex items-center gap-1">
                {formatAddress(act.txHash)}
                <img src="\assets\tabshare.svg" alt="tx" onClick={() => window.open(`${EXPLORER_URL}${act.txHash}`)}/>
              </p>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
